module.exports = ".nav-item a {\n  cursor: pointer; }\n"